import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import connectApi from 'api/connectApi'
import { constants, sendMessageToWorker } from 'helpers'
import {
    InteractionPayloadType,
    ShowWarningModalInterface,
    VisitStatusInterface
} from 'storeTypes'
import { ErrorResponse } from 'types'

export const visitPostAction = createAsyncThunk<
    unknown,
    InteractionPayloadType,
    { rejectValue: string }
>('visit/visitPostAction', async (formPayload, { rejectWithValue }) => {
    const { VISIT } = constants.endpoints

    try {
        sendMessageToWorker({ 'store interaction': formPayload })
        const response = await connectApi.post(VISIT, formPayload)
        return response.data
    } catch (error: unknown) {
        if (error instanceof ErrorResponse) {
            return rejectWithValue(error.response.data.detail)
        }
        return rejectWithValue('something went wrong')
    }
})

const isVisitedInitialState: VisitStatusInterface = { isVisited: false }
const showWarningInitialState: ShowWarningModalInterface = {
    showWarningModal: false
}

const isVisitedSlice = createSlice({
    name: 'isVisited',
    initialState: isVisitedInitialState,
    reducers: {
        setIsVisitedAction: (state, action: PayloadAction<boolean>) => {
            state.isVisited = action.payload
        }
    }
})

const showWarningSlice = createSlice({
    name: 'showWarning',
    initialState: showWarningInitialState,
    reducers: {
        showWarningModalAction: (state, action: PayloadAction<boolean>) => {
            state.showWarningModal = action.payload
        }
    }
})

export const { setIsVisitedAction } = isVisitedSlice.actions
export const { showWarningModalAction } = showWarningSlice.actions
export const setIsVisitedReducer = isVisitedSlice.reducer
export const setShowWarningReducer = showWarningSlice.reducer
